<template>
  <div class="mid-autumn">
    <!-- 活动标题 -->
    <div v-wechat-title='"余杭月饼铺开张营业！"'></div>
    <!-- 首页进入青瓷游戏LOGO -->
    <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut' name='fade'>
      <div @touchmove.prevent class='preloading preloading-hjwq' v-show='preloadingShow'></div>
    </transition>
    <Header
      v-if="activeIndex !== 1 || !isGuide"
      :isOnline="1"
      :config='headerConfig'
      :isShowInfo='true' />

    <MySwiper :noSwiperClass='noSwiperClass' ref="mySwiper">
      <template v-slot:first-slide-content>
        <div class='home-page swiper-no-swiping'>
          <div class="btn_list">
            <div class="detail_btn" @click="openPopup('detailShow')"></div>
            <div class="stop_btn" @click="openPopup('stopShow')"></div>
            <div class="invite_btn" @click="openPopup('inviteRecordShow')"></div>
          </div>
          <div class="decorate_1"></div>
          <div class="decorate_2"></div>
          <div class="title">
            <transition enter-active-class="animated zoomInDown" leave-active-class="animated fadeOut" name="fade">
              <img v-show="titleShow" src="../../../../assets/images/active/hjwq/mid-autumn/title.png"/>
            </transition>
          </div>
          <div class="role_ani">
            <img src="../../../../assets/images/active/hjwq/mid-autumn/role_ani.gif" />
          </div>
          <div class="decorate_3"></div>
          <div class="egg_btn" @click="openPopup('eggShow')"></div>
          <div class="play_btn" @click="onPlay()">
            <img src="../../../../assets/images/active/hjwq/mid-autumn/play_btn.png" alt="">
          </div>
        </div>
      </template>
      <template v-slot:second-slide-content>
        <div class='content-page'>
          <div class="active-content">

            <div class="order_box">
              <div v-if="activeInfo.times !== 0" class="order_detail">
                <div class="sprites-signboard sprites"></div>
              </div>
              <div v-else class="sprites-stop_signboard sprites"></div>

              <div class="info_box">
                <div class="left">
                  <p>未完成订单：{{activeInfo.times || 0}}</p>
                  <p>已完成订单：{{activeInfo.use_times || 0}}</p>
                </div>
                <div class="right">
                  桂花：{{score || 0}}<i class="sprites-osmanthus sprites"></i>
                </div>
              </div>

              <div :class="'moon_cake_img ' + (startAni ? 'hideAni' : 'showAni')">
                <i :class="'materials_sprites-mooncake_'+ (recipe[0] + '_' + recipe[1] + '_' + recipe[2]) + ' materials_sprites'"></i>
              </div>

              <div class="avatar_box">
                <div :class="'avatar sprites sprites-smail_avatar_' + activeInfo.pic_num + (startAni ? ' ani_out' : ' ani_enter')"></div>
              </div>
            </div>

            <div class="menu_box">
              <div class="role"></div>

              <div class="formula_box">
                <div :class="'location_1 materials_sprites materials_sprites-formula_tip_' + selectMaterials[0]"></div>
                <div :class="'location_2 materials_sprites materials_sprites-formula_tip_' + selectMaterials[1]"></div>
                <div :class="'location_3 materials_sprites materials_sprites-formula_tip_' +  + selectMaterials[2]"></div>
                <div v-if="!selectMaterials[0] || !selectMaterials[1] || !selectMaterials[2]">
                  <div class="materials_sprites materials_sprites-empty"></div>
                </div>
                <div v-else :class="'location_4 materials_sprites materials_sprites-small_mooncake_' + selectMaterials[0] + '_' + selectMaterials[1] + '_' + selectMaterials[2]"></div>
                <span class="add_1">+</span>
                <span class="add_2">+</span>
                <span class="equal">=</span>
              </div>
            </div>

            <!-- swing_ani open_ani -->
            <div :class="'gift_box ' + giftBoxClass"></div>

            <div class="materials_box">
              <ul class="name">
                <li v-for="item in materials" :key="item"
                  :class="'materials_sprites materials_sprites-material_name_' + item"></li>
              </ul>
              <ul class="images">
                <li v-for="item in materials" :key="item"
                  :class="'materials_sprites materials_sprites-material_img_' + item + (selectMaterials.includes(item) ? ' on' : '')"
                  @click="onSelectedMaterials(item)"></li>
              </ul>
            </div>


            <div class="operation_btn">
              <div class="detail_btn" @click="openPopup('detailShow')"></div>
              <div class="exchange_btn" @click="openPopup('stopShow')"></div>
              <div class="record_btn" @click="openPopup('inviteRecordShow')"></div>
              <div class="sprites-invite_btn sprites invite_btn" @click="openPopup('inviteShow')"></div>
              <div class="sprites-make_btn sprites make_btn" @click="onMake()"></div>
            </div>
            <!-- 新手指导 -->
            <div class="guide_box" v-if="isGuide" @click="onNextStep()">
              <div v-if="stepIdx <= 12" class="guide_img guide_img_12"></div>
              <div v-if="stepIdx <= 11" class="guide_img guide_img_11">
                <div class="next_btn"></div>
              </div>
              <div v-if="stepIdx <= 10" class="guide_img guide_img_10">
                <div class="next_btn"></div>
              </div>
              <div v-if="stepIdx <= 9" class="guide_img guide_img_9">
                <div class="next_btn" @click.stop="onMakeByGuide()"></div>
              </div>
              <div v-if="stepIdx <= 8" class="guide_img guide_img_8"></div>
              <div v-if="stepIdx <= 7" class="guide_img guide_img_7"></div>
              <div v-if="stepIdx <= 6" class="guide_img guide_img_6">
                <div class="next_btn" @click.stop="changeStep(7)"></div>
              </div>
              <div v-if="stepIdx <= 5" class="guide_img guide_img_5">
                <div class="next_btn" @click.stop="changeStep(6)"></div>
              </div>
              <div v-if="stepIdx <= 4" class="guide_img guide_img_4">
                <div class="next_btn" @click.stop="changeStep(5)"></div>
              </div>
              <div v-if="stepIdx <= 3" class="guide_img guide_img_3"></div>
              <div v-if="stepIdx <= 2" class="guide_img guide_img_2"></div>
              <div v-if="stepIdx <= 1" class="guide_img guide_img_1"></div>
            </div>
          </div>

          <Footer :gameName="gameName" />
        </div>
        <div class="share_box" ref="imageDom">
          <img src="../../../../assets/images/active/hjwq/mid-autumn/popup/invite_link_popup.png" alt="邀请" />
          <div class="link">{{shareLink}}</div>
          <div class="share-img">
            <div class="qrcode-box">
              <div id="qrcode" class="qrcode"></div>
            </div>
          </div>
        </div>
      </template>
    </MySwiper>

    <!-- 弹窗类 -->
    <!-- 活动详情 -->
    <div class="detail_wrap popup_wrap" v-show="detailShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="detail_box" v-show="detailShow">
          <div class="detail">
            <img src="../../../../assets/images/active/hjwq/mid-autumn/popup/role_detail.png" alt="详情">
          </div>
        </div>
      </transition>
      <div class="close-bg" v-if="detailShow" @click="closePopup('detailShow')"></div>
    </div>
    <!-- 彩蛋 -->
    <div class="egg_wrap popup_wrap" v-show="eggShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="egg_box" v-show="eggShow" id="clipboard-egg-btn"
          :data-clipboard-text="eggText"  @click="onCopyEgg()"></div>
      </transition>
      <div class="close-bg" v-if="eggShow" @click="closePopup('eggShow')"></div>
    </div>
    <!-- 邀请记录 -->
    <div class="invite_record_wrap popup_wrap" v-show="inviteRecordShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="invite_box" v-show="inviteRecordShow">
          <ul>
            <li v-for="item, idx of (activeInfo.friend_list || [])" :key="idx">
              <div class="item">
                <div class="left">
                  <div class="avatar">
                    <img :src="item.avatar" alt="">
                  </div>
                  <div class="user_name">{{item.nickname}}</div>
                </div>
                <div class="right">{{item.created_at}}</div>
              </div>
            </li>
          </ul>
        </div>
      </transition>
      <div class="close-bg" v-if="inviteRecordShow" @click="closePopup('inviteRecordShow')"></div>
    </div>
    <!-- 兑换商店 -->
    <div class="stop_wrap popup_wrap" v-show="stopShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="stop_box" v-show="stopShow">
          <div class="close_btn" @click="closePopup('stopShow')"></div>
          <div class="record_btn" @click="openPopup('recordShow')"></div>
          <div class="goods">
            <div v-for="(product, idx) in goods"
              :key="idx"
              :class="'product product_' + product.packageId"
              @click="openExchangePopup(product.packageId)">
              <div :class="product.image_name + ' sprites product_icon'"></div>
              <p>限购({{product.exchangeNum || 0}}/{{product.limit}})</p>
              <h5>{{product.name}}</h5>
              <div class="exchange_box">
                <i class="sprites-osmanthus sprites"></i>
                <span>x&nbsp;{{product.amount}}&nbsp;兑换</span>
              </div>
            </div>
          </div>
          <div class="amount_box">
            <span>剩余</span>
            <i class="sprites-osmanthus sprites"></i>
            <span>：{{score || 0}}</span>
          </div>
        </div>
      </transition>
      <div class="close-bg" v-if="stopShow" @click="closePopup('stopShow')"></div>
    </div>
    <!-- 兑换记录 -->
    <div class="record_wrap popup_wrap" v-show="recordShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="record_box" v-show="recordShow">
          <div class="record_list">
            <div class="header">
              <div class="product_name">
                <span class="rhombus"></span>道具奖励
              </div>
              <div class="intro">
                <span class="rhombus"></span>消耗桂花数量
              </div>
              <div class="date">
                <span class="rhombus"></span>兑换时间
              </div>
            </div>
            <ul class="list">
              <li v-for="item of exchangeRecord" :key="item.id">
                <div class="product_name">{{item.remark}}</div>
                <div class="intro">消耗<i class="sprites-osmanthus sprites"></i>*{{Math.abs(item.score)}}</div>
                <div class="date">{{item.created_at}}</div>
              </li>
            </ul>
          </div>
        </div>
      </transition>
      <div class="close-bg" v-if="recordShow" @click="closePopup('recordShow')"></div>
    </div>
    <!-- 单个商品兑换 -->
    <div class="exchange_wrap popup_wrap" v-show="exchangeShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="exchange_box" v-show="exchangeShow">
          <div :class="'product_img sprites sprites-prize_' + curProduct.packageId"></div>
          <p class="product_name">{{curProduct.name}}</p>
          <div class="option">
            <div class="sprites-minus_btn sprites" @click="minusNum()"></div>
            <div :class="'num ' + (curProduct.curNum && 'black')">{{
              curProduct.curNum ? curProduct.curNum : (
                curProduct.max === 0 ? '无法兑换' : ('(1-' + curProduct.max + ')')
              )
            }}</div>
            <div class="sprites-add_btn sprites" @click="addNum()"></div>
            <div class="sprites-max_btn sprites" @click="maxExchange()"></div>
          </div>
          <div class="amount">
            消耗<i class="sprites-osmanthus sprites"></i>数量: {{curProduct.totalPrices || 0}}
          </div>
          <div class="sprites-exchange_btn sprites" @click="onExchange()"></div>
        </div>
      </transition>
      <div class="close-bg" v-if="exchangeShow" @click="closePopup('exchangeShow')"></div>
    </div>
    <!-- 兑换成功 -->
    <div class="exchange_success_wrap popup_wrap" v-show="exchangeSuccessShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="exchange_success_box" v-show="exchangeSuccessShow">
          <div class="confirm_btn" @click="closePopup('exchangeSuccessShow')"></div>
        </div>
      </transition>
      <div class="close-bg" v-if="exchangeSuccessShow" @click="closePopup('exchangeSuccessShow')"></div>
    </div>
    <!-- 今日任务完成 -->
    <div class="tip_complete_wrap popup_wrap" v-show="tipCompleteShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="tip_complete_box" v-show="tipCompleteShow">
          <div class="confirm_btn" @click="closePopup('tipCompleteShow')"></div>
        </div>
      </transition>
      <div class="close-bg" v-if="tipCompleteShow" @click="closePopup('tipCompleteShow')"></div>
    </div>
    <!-- 邀请提示 -->
    <div class="tip_invite_wrap popup_wrap" v-show="tipInviteShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="tip_invite_box" v-show="tipInviteShow">
          <div class="confirm_btn" @click="closePopup('tipInviteShow')"></div>
        </div>
      </transition>
      <div class="close-bg" v-if="tipInviteShow" @click="closePopup('tipInviteShow')"></div>
    </div>
    <!-- 邀请弹窗 -->
    <div class="invite_wrap popup_wrap" v-show="inviteShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="invite_box" v-show="inviteShow">
          <img :src="shareImg" alt="">
          <div class="copy_btn" id="clipboard-share-btn"
            :data-clipboard-text="'【新仙剑之挥剑问情】余杭月饼铺开门营业，助力我拿下订单，赚更多金龙啦！ ' + shareLink + '?id=' + userInfo.user_id" @click="onCopyShareLink()"></div>
        </div>
      </transition>
      <div class="close-bg" v-if="inviteShow" @click="closePopup('inviteShow')"></div>
    </div>
    <!-- 月饼 -->
    <div class="moon_cake_popup popup_wrap" v-show="moonCakeShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div :class="'moon_cake_box ' + moonClass" v-show="moonCakeShow"
          @click.stop="closeMoonCakePopup()">
        </div>
      </transition>
      <div class="close-bg" v-if="moonCakeShow" @click.stop="closeMoonCakePopup()"></div>
    </div>
    <!-- 获得桂花奖励 -->
    <div class="tip_prop_wrap popup_wrap" v-show="tipPropShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="tip_prop_box" v-show="tipPropShow">
          <div class="confirm_btn" @click="closeTipAwardPopup()"></div>
        </div>
      </transition>
    </div>
    <!-- 配方错误 -->
    <div class="fail_tip_warp popup_wrap" v-show="failTipShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="fail_tip_box" v-show="failTipShow">
          <div class="confirm_btn" @click="closeFailTipPopup()"></div>
        </div>
      </transition>
    </div>
    <!-- 额外的每日奖励  -->
    <div class="every_day_award_warp popup_wrap" v-show="everyDayAwardShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="every_day_award_box" v-show="everyDayAwardShow">
          <div class="confirm_btn" @click="closePopup('everyDayAwardShow')"></div>
        </div>
      </transition>
    </div>

    <!-- 预加载图片 -->
    <img style="display: none" src="../../../../assets/images/active/hjwq/mid-autumn/popup/role_detail.png" alt="">
    <img style="display: none" src="../../../../assets/images/active/hjwq/mid-autumn/guide/1.jpg" alt="">
    <img style="display: none" src="../../../../assets/images/active/hjwq/mid-autumn/guide/2.jpg" alt="">
    <img style="display: none" src="../../../../assets/images/active/hjwq/mid-autumn/guide/3.jpg" alt="">
    <img style="display: none" src="../../../../assets/images/active/hjwq/mid-autumn/guide/4.jpg" alt="">
    <img style="display: none" src="../../../../assets/images/active/hjwq/mid-autumn/guide/5.jpg" alt="">
    <img style="display: none" src="../../../../assets/images/active/hjwq/mid-autumn/guide/6.jpg" alt="">
    <img style="display: none" src="../../../../assets/images/active/hjwq/mid-autumn/guide/7.jpg" alt="">
    <img style="display: none" src="../../../../assets/images/active/hjwq/mid-autumn/guide/8.jpg" alt="">
    <img style="display: none" src="../../../../assets/images/active/hjwq/mid-autumn/guide/9.jpg" alt="">
    <img style="display: none" src="../../../../assets/images/active/hjwq/mid-autumn/guide/10.jpg" alt="">
    <img style="display: none" src="../../../../assets/images/active/hjwq/mid-autumn/guide/11.jpg" alt="">
    <img style="display: none" src="../../../../assets/images/active/hjwq/mid-autumn/guide/12.jpg" alt="">

    <!-- 登录弹窗 -->
    <Login v-if='isShowLogin'
      v-on:channelCallback='selectCallback'
      :gameName="gameName"
      downloadUrl="https://static.qcplay.com/tideng/official/"
      channelTips="角色UID可在游戏中—头像—ID查看"></Login>
    <Os v-if='isShowOs'
      v-on:selectCallback='selectCallback'
      v-on:logoutCallback='osCancell'
      :gameName="gameName"></Os>


    <!-- 全局遮罩 -->
    <div :class="'prevent-wrap prevent-wrap-' + preventShow"></div>
  </div>
</template>
<script>
// import { fabric } from 'fabric';
import { Indicator, Toast } from 'mint-ui';
import Clipboard from 'clipboard';
import { mapState, mapMutations, mapActions } from 'vuex';
import Os from '@/components/os';
import Login from '@/components/login';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import MySwiper from '@/components/MySwiper';
import { headerConfig } from '../headerConfig';
import { getRandomString, buriedLogger } from '@/utils/utils';
import { generateQRCode, generateCanvasImage } from '@/utils/share';
import { onGetInitDataAPI, onMakeMoonCakeAPI, onExchangeProductAPI } from '../api';

// import InviteImage from '@/assets/images/active/hjwq/mid-autumn/popup/invite_link_popup.png';


const GOODS = [
  { name: '金龙', limit: 50, amount: 1, packageId: 2, image_name: 'sprites-product_2' },
  { name: '祈愿符', limit: 10, amount: 5, packageId: 1, image_name: 'sprites-product_1' },
  { name: '新安当票', limit: 10, amount: 6, packageId: 3, image_name: 'sprites-product_3' },
  { name: '至尊召唤券', limit: 3, amount: 20, packageId: 4, image_name: 'sprites-product_4' },
  { name: '五系招募石', limit: 5, amount: 14, packageId: 5, image_name: 'sprites-product_5' },
];

const goods = [...GOODS].map((item) => {
  return { ...item, exchangeNum: 0 };
})

export default {
  name: 'mid-autumn',
  components: {
    Header,
    Footer,
    Login,
    Os,
    MySwiper
  },
  data () {
    return {
      headerConfig,
      gameName: 'hjwq',
      preloadingShow: false,
      titleShow: true,
      noSwiperClass: '', // swiper-no-swiping
      shareLink: '', // 助力链接
      shareImg: null,
      preventShow: false,
      swiper: null,
      logger: null,

      activeIndex: 0,

      detailShow: false,
      eggShow: false,
      eggText: '小兔子乖乖',
      inviteRecordShow: false,
      inviteShow: false,
      stopShow: false,
      recordShow: false,
      exchangeShow: false,
      exchangeSuccessShow: false,
      tipCompleteShow: false,
      tipInviteShow: false,
      tipPropShow: false,
      moonCakeShow: false,
      failTipShow: false,
      everyDayAwardShow: false,

      isGuide: false,
      stepIdx: 0,

      isEvery: false,
      startAni: false, // 启动动画
      productListName: ['祈愿符x1', '金龙x50', '新安当票x1', '至尊召唤券x1', '五系招募石x1'],
      materials: Array.from((new Array(8)), (item, idx) => idx + 1),

      giftBoxClass: '',
      moonClass: '',
      score: 0, // 当前桂花数量
      curMoonCakeIdx: 0, // 当前月饼id
      goods: [...goods],
      exchangeRecord: [],
      recipe: Array.from((new Array(3)), () => 0), // 订单需要的素材
      selectMaterials: Array.from((new Array(3)), () => 0),
      curProduct: {
        packageId: 1,
        name: '',
        amount: 0,
        max: 0, // 当前最多兑换数量
        limit: 0, // 当前商品兑换的上限
        exchangeNum: 0, // 已兑换数量
        curNum: 0, // 当前选择的数量
        totalPrices: 0, // 总价
      },
    };
  },
  created () {
    const { protocol, host } = window.location;

    setTimeout(() => {
      this.mySwiper();
      // 清空store上的用户数据
      this.setInitActiveInfo();
      this.setInitUserInfo();
      this.onInit();
    }, 100);

    // 埋点
    const bl = buriedLogger('hjwq', '中秋活动_首页');
    this.logger = bl;

    this.shareLink = `${protocol}//${host}/hjwq/mid-autumn/help${getRandomString()}`;

    this.setShare({
      title: '余杭月饼铺开张营业！',
      desc: '制作月饼赚金龙咯~',
      imgUrl: 'https://download4.qcplay.com/qcgame-admin/8TYvz9Cy2qyhLOYSn5lBbCgSDNNa0zsIKFmwiNHo.png',
      link: `${protocol}//${host}/hjwq/mid-autumn/enter${getRandomString()}`,
    });

  },
  computed: {
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
      'isShowOs'
    ])
  },
  watch: {
    userInfo: {
      handler (newValue, oldValue) {
        if (!newValue.role_id) {
          // TAG: 未登录或者注销的时候
          this.clearData();
        } else if (newValue.role_id !== oldValue.role_id) {
          // 切号的时候
          this.initShareData(newValue);
        }
      }
    },
    activeInfo: {
      handler (newValue, oldValue) {
        if (Object.keys(newValue).length > 0) {
          const { exchange_info = [], need, total_score, exchange_record = [], is_first } = newValue;
          let timer = 0;
          if (this.startAni) {
            timer = 600;
          }
          setTimeout(() => {
            this.recipe = need;
            this.startAni = false;
          }, timer);
          this.score = total_score;
          this.exchangeRecord = exchange_record;
          this.goods =  [...GOODS].map(item => {
            const { packageId } = item;
            const data = exchange_info.find(product => product.id === packageId);
            return { ...item, exchangeNum: data && data.buy_number || 0 };
          });
          const isGuide = is_first === 0;
          this.isGuide = isGuide;
          this.stepIdx = isGuide ? 1 : 0;
          // this.noSwiperClass = isGuide ? 'swiper-no-swiping' : '';
        }
      }
    }
  },
  methods: {
    initShareData (info) {
      // setTimeout(() => {
      //   this.qrcode(`${this.shareLink}?id=${info.user_id}`);
      //   this.generateShareImage();
      // }, 100);
      this.qrcode(`${this.shareLink}?id=${info.user_id}`);
      this.$nextTick(() => {
        this.generateShareImage();
      });
    },
    qrcode (link) {
      generateQRCode(document.getElementById('qrcode'), {
        text: link,
        colorDark: '#ffddac', // ffddac
        colorLight: '#835031' // 835031
      });
    },
    // 分享图片设置
    generateShareImage () {
      generateCanvasImage(this.$refs.imageDom)
        .then((canvas) => {
          this.shareImg = canvas.toDataURL('image/png'); // 可将 canvas 转为 base64 格式
          console.log('success: 图片生成成功');
        })
        .catch((err) => {
          console.log('err: 图片生成失败', err.message);
        });
    },
    // 选择角色后
    selectCallback () {
      this.onInit();
    },
    // 区组弹窗注销-相关参数复位
    osCancell () {
      this.clearData();
    },
    // 清楚数据
    clearData () {
      this.isGuide = false;
      this.giftBoxClass = '';
      this.moonClass = '';
      this.score = 0;
      this.curMoonCakeIdx = 0;
      this.recipe = Array.from((new Array(3)), () => 0);
      this.selectMaterials = Array.from((new Array(3)), () => 0);

      this.exchangeRecord = [];
      this.goods = [...goods];
      this.curProduct = {
        packageId: 0,
        name: '',
        amount: 0,
        max: 0,
        limit: 0,
        exchangeNum: 0,
        curNum: 0,
        totalPrices: 0,
      };
    },
    // swiper轮播
    mySwiper () {
      this.$refs.mySwiper.init({
        allowSlidePrev: false,
        shortSwipes: false,
        onInit: swiper => { this.swiper = swiper; },
        onSlideChangeEnd: swiper => { this.activeIndex =swiper.activeIndex; },
      });
    },
    // 初始化用户信息
    onInit (cb) {
      onGetInitDataAPI().then(response => {
        const isRefresh = Number(localStorage.getItem('is_refresh')) === 1;
        if (isRefresh && response.code === 200) {
          localStorage.setItem('is_refresh', 0);
          setTimeout(() => {
            window.location.reload();
          }, 10);
        } else if (response.code === 302) {
          localStorage.setItem('is_refresh', 1);
        }
        this.onInitDataCallback(response);
        cb && cb();
      });
    },
    onCopyEgg () {
      this.onCopy('#clipboard-egg-btn');
      this.logger.sum('中秋_复制密令');
    },
    onCopyShareLink () {
      this.onCopy('#clipboard-share-btn');
      this.logger.sum('中秋_复制分享链接');
    },
    openExchangePopup (id) {
      // 未登录
      if (this.userInfo.role_id === undefined) {
        this.closePopup('stopShow');
        this.changeLoginPopup(true);
        return false;
      }
      const curProduct = this.goods.find(item => item.packageId === id);
      const { limit, exchangeNum, amount } = curProduct;
      console.log('curProduct', curProduct)
      const residueLimit = Math.max(0, limit - exchangeNum);
      const scoreLimit = Math.max(Math.floor(this.score / amount), 0);
      console.log('residueLimit:', residueLimit, '   scoreLimit:', scoreLimit);
      const max = Math.max(0, Math.min(residueLimit, scoreLimit));
      console.log('max', max);
      this.curProduct = {
        packageId: id,
        name: this.productListName[id - 1],
        amount,
        max, // 当前最多兑换数量
        limit, // 当前商品兑换的上限
        exchangeNum: Number(exchangeNum) || 0, // 已兑换数量
        curNum: 0,
        totalPrices: 0,
      };
      this.openPopup('exchangeShow');
    },
    // 兑换商品计算
    addNum () {
      const { max, curNum, exchangeNum, limit, amount } = this.curProduct;
      if (exchangeNum === limit) {
        this.onToast('当前道具兑换上限');
        return false;
      } else if (max === 0) {
        this.onToast('桂花数量不足');
        return false;
      }
      this.curProduct.curNum = Math.min(curNum + 1, max);
      this.curProduct.totalPrices = this.curProduct.curNum * amount;
    },
    minusNum () {
      const { max, curNum, exchangeNum, limit, amount } = this.curProduct;
      if (exchangeNum === limit) {
        this.onToast('当前道具兑换上限');
        return false;
      } else if (max === 0) {
        this.onToast('桂花数量不足');
        return false;
      }
      this.curProduct.curNum = Math.max(curNum - 1, 0);
      this.curProduct.totalPrices = this.curProduct.curNum * amount;
    },
    maxExchange () {
      const { exchangeNum, limit, amount } = this.curProduct;
      if (exchangeNum === limit) {
        this.onToast('当前道具兑换上限');
        return false;
      }
      this.curProduct.curNum = this.curProduct.max;
      this.curProduct.totalPrices = this.curProduct.curNum * amount;
    },
    onExchange () {
      if (!this.curProduct.curNum) {
        this.onToast('请选择兑换的数量');
        return false;
      }
      // TODO: 发起接口
      this.preventShow = true;
      Indicator.open();
      onExchangeProductAPI({
        exchange_id: this.curProduct.packageId,
        number: this.curProduct.curNum
      }).then((response) => {
        this.preventShow = false;
        Indicator.close();
        this.closePopup('exchangeShow');
        this.openPopup('exchangeSuccessShow');
        this.onInit();
      }).catch(() => {
        this.preventShow = false;
        Indicator.close();
      });
    },
    onPlay () {
      if (this.userInfo.role_id === undefined) {
        this.changeLoginPopup(true);
        return false;
      }
      this.swiper.slideTo(1);
      this.logger.sum('中秋_开始营业');
    },
    onSelectedMaterials (val) {
      let idx = 0;
      const materials = [...this.selectMaterials];
      if (val >= 7) {
        idx = 2;
      } else if (val >= 3) {
        idx = 1;
      }
      materials[idx] = val;
      this.selectMaterials = materials;
    },
    onMake () {
      if (this.userInfo.role_id === undefined) {
        this.changeLoginPopup(true);
        return false;
      }
      if (this.activeInfo.times <= 0) {
        if (this.activeInfo.help_times === 0) {
          this.openPopup('tipCompleteShow');
        } else {
          this.openPopup('tipInviteShow');
        }
        return false;
      }
      if (this.selectMaterials.includes(0)) {
        this.onToast('好像还缺少什么食材，再想想吧~');
        return false;
      }
      this.preventShow = true;
      this.giftBoxClass = 'swing_ani';
      onMakeMoonCakeAPI({
        order_id: this.activeInfo.order,
        answer: this.selectMaterials.join(',')
      }).then((response) => {
        const { is_add, send_reward } = response.data;
        this.isEvery = send_reward;
        // 动画效果
        setTimeout(() => {
          this.giftBoxClass = 'open_ani';
        }, 1800);

        // 弹窗以及更新数据
        setTimeout(() => {
          if (is_add === 1) {
            this.moonClass = `m_${this.recipe[0]}_${this.recipe[2]}`;
            this.openPopup('moonCakeShow');
          } else {
            // 制作失败
            this.openPopup('failTipShow');
          }
          this.preventShow = false;
        }, 2500);
      }).catch(() => {
        this.preventShow = false;
        Indicator.close();
        this.giftBoxClass = '';
      });
      this.logger.sum('中秋_制作月饼');
    },
    closeTipAwardPopup () {
      this.giftBoxClass = '';
      this.preventShow = true;
      this.closePopup('tipPropShow');
      this.onInit();
      this.selectMaterials = Array.from((new Array(3)), () => 0);
      this.startAni = true;
      if (this.isEvery) {
        this.openPopup('everyDayAwardShow');
        this.isEvery = false;
        this.preventShow = false;
      } else {
        setTimeout(() => {
          this.preventShow = false;
        }, 1200);
      }
      this.logger.sum('中秋_关闭获取桂花提示');
    },
    closeFailTipPopup () {
      this.giftBoxClass = '';
      this.closePopup('failTipShow');
      this.preventShow = true;
      this.onInit();
      this.selectMaterials = Array.from((new Array(3)), () => 0);
      this.startAni = true;
      setTimeout(() => {
        this.preventShow = false;
      }, 1200);
      this.logger.sum('中秋_关闭配方错误提示');
    },
    closeMoonCakePopup () {
      this.closePopup('moonCakeShow');
      if (this.isGuide) {
        this.stepIdx = 10;
        return false;
      }
      this.openPopup('tipPropShow');
    },
    changeStep (stepIdx) {
      this.stepIdx = stepIdx;
    },
    onNextStep () {
      if ([4, 5, 6, 9].includes(this.stepIdx)) {
        return false;
      }
      if (this.stepIdx === 12) {
        this.preventShow = true;
        this.onInit();
        this.startAni = true;
        setTimeout(() => {
          this.preventShow = false;
        }, 1200);
        return false;
      }
      this.stepIdx ++;
    },
    onMakeByGuide () {
      this.preventShow = true;
      onMakeMoonCakeAPI({
        order_id: this.activeInfo.order,
        answer: '1,3,8'
      }).then((response) => {
        const { is_add } = response.data;
        if (is_add === 1) {
          this.preventShow = false;
          this.moonClass = 'm_1_8';
          this.openPopup('moonCakeShow');
        }
      });
    },
    // TAG: 其他简易封装的方法
    openPopup (name) {
      if (['inviteShow'].includes(name) && this.userInfo.role_id === undefined) {
        this.changeLoginPopup(true);
        return false;
      }
      this[name] = true;
      const logConfig = {
        'detailShow': '活动详情',
        'eggShow': '彩蛋',
        'inviteRecordShow': '邀请记录',
        'inviteShow': '邀请',
        'stopShow': '兑换商店',
        'recordShow': '兑换记录'
      };
      logConfig[name] && (this.logger.sum(`中秋_打开${logConfig[name]}弹窗`));
    },
    closePopup (name) {
      this[name] = false;
    },
    // 复制
    onCopy (domName) {
      const clipboard = new Clipboard(domName);
      clipboard.on('success', (e) => {
        if (domName === '#clipboard-egg-btn') {
          this.onToast('密令复制成功');
        } else {
          this.onToast('复制成功');
        }
        e.clearSelection();
      });

      clipboard.on('error', (e) => {
        this.onToast('复制失败');
      });
      this.logger.sum('anniversary_copy_link');
    },
    onToast (config) {
      const curConfig = {
        duration: 1000,
        className: 'toasts'
      };
      if (!config) {
        console.error('缺少config参数');
        return false;
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    ...mapMutations([
      'changeLoginPopup',
      'changeOsPopup',
      'setInitActiveInfo',
      'setInitUserInfo',
      'setActiveInfo',
      'setLogger'
    ]),
    ...mapActions([
      'onInitDataCallback',
      'setShare'
    ])
  },
};
</script>

<style lang='less'>
  @import url('./index.less');
</style>



// WEBPACK FOOTER //
// src/pages/hjwq/mid-autumn/index/index.vue